const OrdersTableSkeleton = ({ columns = 7, rows = 4 }) => {
    return (
        <div className="myaccountDiv orderDiv">
            <ul className="tableHdn">
                {Array.from({ length: columns }).map((_, index) => (
                    <li key={`order-head-skeleton-${index}`}>
                        <div className="skeleton" style={{ height: 14, width: "70%" }} />
                    </li>
                ))}
            </ul>

            {Array.from({ length: rows }).map((_, rowIndex) => (
                <div className="orderMain" key={`order-row-skeleton-${rowIndex}`}>
                    <ul className="tableDesc">
                        {Array.from({ length: columns }).map((__, colIndex) => (
                            <li key={`order-cell-skeleton-${rowIndex}-${colIndex}`}>
                                <div className="skeleton" style={{ height: 16, width: colIndex === columns - 1 ? "60%" : "75%" }} />
                            </li>
                        ))}
                    </ul>
                </div>
            ))}
        </div>
    );
};

export default OrdersTableSkeleton;
